var map = {
	"./beer.svg": 587,
	"./cases_meldedatum_.csv": 488,
	"./icons__beer_b.png": 106,
	"./icons__beer_b.svg": 314,
	"./icons__beer_is.png": 534,
	"./icons__beer_is.svg": 384,
	"./icons__header_2.png": 915,
	"./icons__header_desk.png": 986,
	"./icons__headerquestion.png": 672,
	"./icons__pattern.png": 577,
	"./icons__row_1.png": 959,
	"./icons__row_2.png": 492,
	"./icons__row_3.png": 621,
	"./icons__snaps_b.png": 115,
	"./icons__snaps_b.svg": 533,
	"./icons__snaps_is.png": 249,
	"./icons__snaps_is.svg": 673,
	"./icons__wine_b.png": 991,
	"./icons__wine_b.svg": 288,
	"./icons__wine_is.png": 381,
	"./icons__wine_is.svg": 899,
	"./icons_arrow_left.png": 499,
	"./icons_arrow_right.png": 204,
	"./icons_arrow_up.png": 179,
	"./icons_beer_b.svg": 21,
	"./icons_beer_is.png": 261,
	"./icons_beer_is.svg": 409,
	"./icons_snaps_b.svg": 180,
	"./icons_snaps_is.png": 892,
	"./icons_snaps_is.svg": 910,
	"./icons_wine_b.svg": 456,
	"./icons_wine_is.png": 714,
	"./icons_wine_is.svg": 594,
	"./illus_amount.svg": 993,
	"./illus_frequency.svg": 709,
	"./illus_risk.svg": 416,
	"./readme.md": 64,
	"./snaps Kopie.svg": 500,
	"./snaps.svg": 188,
	"./wine.svg": 938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;